export function generateTicketNumber(): string {
  const random = Math.floor(10000 + Math.random() * 90000);

  return `DR-${random}`;
}

export function generateAccessToken(): string {
  if (typeof crypto !== 'undefined' && crypto.randomUUID) {
    return (
      crypto.randomUUID().replace(/-/g, '') +
      Math.random().toString(36).substring(2, 10)
    );
  }

  return (
    Math.random().toString(36).substring(2) +
    Math.random().toString(36).substring(2)
  );
}
